import Service from "../Service";

const resource = "approvaltransaction/";

export default {
    save(obj, requestID) {
        return Service.post(resource + "savemasive", obj, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "slopes", parameters, {
            params: { requestID: requestID },
        });
    },


};